<template>
    <div style="max-width:800px;margin:0 auto">
        <div class="container">
            <el-header> 
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 测评</el-breadcrumb-item>
                    <el-breadcrumb-item>DISC性格测评</el-breadcrumb-item>
                </el-breadcrumb>
            </el-header>
            <el-header>
                <h2 id="typography-zi-ti">DISC性格测评</h2>
            </el-header>
            <el-main>

            </el-main>
        </div>

        <div class="container" style="width:400px;margin:0 auto">
            <el-header> 
                <el-row>
                    请正确输入姓名和手机号码
                </el-row>
            </el-header>
            <el-row size="large" style="padding:20px">
                <el-input placeholder="请输入姓名" v-model="params.username">
                    <template slot="prepend"><i class="el-icon-user-solid"></i></template>
                </el-input>
            </el-row>
            <el-row size="large" style="padding:10px 20px">
                <el-input placeholder="请输入手机号码" v-model="params.phone">
                    <template slot="prepend"><i class="el-icon-phone"></i></template>
                </el-input>
            </el-row>
            <el-row size="large"  style="margin-top:10px">
                <el-button type="" @click="onSubmit">开始答题</el-button>
                <!-- <el-button type="" @click="download">下载</el-button> -->
            </el-row>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'baseform',
        data: function(){
            return {
                
                params:{
                    username: "",
                    phone: ""
                }
            }
        },
        mounted() {
            console.log(this.$route.query.username)
            console.log(this.$route.query.id)
            let username = this.$route.query.username;
            let phone = this.$route.query.phone;
            let id = this.$route.query.id;
            if(username){
                this.params.username = username;
            }
            if(phone){
                this.params.phone = phone;
            }
            if(id){
                this.params.id = id;
            }

            if(this.$route.params.msg){
                this.$alert( this.$route.params.msg,'提示', {
                    confirmButtonText: '确定'
                });
            }
        },
        methods: {
            onSubmit() {
                if(!this.params.username){
                    this.showMsgBox("请输入姓名！");
                    return;
                }else if(this.params.username.length > 20){
                    this.showMsgBox("姓名过长，请正确输入姓名！");
                    return;
                }
                var myreg=/^[1][3,4,5,6.7,8,9][0-9]{9}$/;
                if(!this.params.phone){
                    this.showMsgBox("请输入手机号码！");
                    return;
                }else if(!myreg.test(this.params.phone)){
                    this.showMsgBox("请正确输入手机号码！");
                    return;
                }
                //带参数跳转
                this.$router.push({name:'answer',query: this.params});
            },
            //错误信息提示
            showMsgBox(msg,title){
                this.$alert(msg, title, {
                    confirmButtonText: '确定',
                    type: 'warning',
                    center: true,
                    'close-on-press-escape':false,
                    'close-on-click-modal':false
                }).then(() => {
                    this.xuhao = 1;
                    this.result = [];
                    this.percentage = 0;
                    this.getDiscOptionData();
                });
            },
            download(){
                this.$axios.post('http://39.106.173.121:8088/api/getDiscResultData', {user_id:1}).then( res => {
                    console.log(res.data)
                })
                // window.location.href="http://127.0.0.1:8088/api/downloadDiscFile?user_id=1";
            }
        }
    }
</script>
<style>
    .question {
        width:100%;
        text-align: center;
    }
    .question button{
        width:70%;
        border-radius: 4px;
        padding:20px 25px;
        text-align: left;
        line-height: 18px;
        white-space: break-spaces;
        box-shadow: 5px 4px 5px #888 !important;
    }
    .el-button.is-plain:focus, .el-button.is-plain:hover {
        background: #FFF;
        border-color: #DCDFE6;
        color: #606266;
    }
    .el-button--primary.is-plain:active {
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
    }
    .el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
    }
    .el-button--danger.is-plain:active {
        color: #F56C6C;
        background: #fef0f0;
        border-color: #fbc4c4;
    }
    .el-button--danger.is-plain:focus, .el-button--danger.is-plain:hover {
        color: #F56C6C;
        background: #fef0f0;
        border-color: #fbc4c4;
    }
    .el-dialog .el-button--primary span{
        color: #fff;
    }
    /* .el-row {
        margin-bottom: 20px;
    } */
    .el-col {
        border-radius: 4px;
    }
    .el-badge__content.is-fixed{
        right:19%;
    }
</style>